import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environment/environment';
import { PortState } from '../models/port.model';

const DEFAULT_LIMIT = 50;

@Injectable({
  providedIn: 'root',
})
export class PortStateService {
  private readonly apiUrl = `${environment.apiUrl}/port-states`;

  constructor(private http: HttpClient) {}

  getLatestState(relayPortId: string): Observable<PortState | null> {
    const params = new HttpParams().set('relayPortId', relayPortId);
    return this.http.get<PortState | null>(`${this.apiUrl}/latest`, { params });
  }

  getHistory(
    relayPortId: string,
    limit: number = DEFAULT_LIMIT,
    before?: string | null,
  ): Observable<PortState[]> {
    let params = new HttpParams()
      .set('relayPortId', relayPortId)
      .set('limit', limit);

    if (before) {
      params = params.set('before', before);
    }

    return this.http.get<PortState[]>(this.apiUrl, { params });
  }
}
